define('OutSystems/ReactWidgets/Switch',["require", "exports", "tslib", "OutSystems/ReactView/HtmlTags", "OutSystems/ReactView/Widget", "react"], function (require, exports, tslib_1, HtmlTags_1, Widget_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Switch = void 0;
    var Switch = (function (_super) {
        tslib_1.__extends(Switch, _super);
        function Switch(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.state = { value: props.variable.value };
            return _this;
        }
        Switch.prototype.onChange = function (e) {
            var _this = this;
            var elem = e.target;
            this.props.variable.value = elem.checked;
            this.setState({ value: elem.checked }, function () {
                if (_this.props.onChange) {
                    _this.executeAfterPaint(function () {
                        _this.executeWithActiveClassOn(function () { return _this.props.onChange(); });
                    });
                }
            });
        };
        Object.defineProperty(Switch.prototype, "htmlElement", {
            get: function () {
                return this.getHTMLNode();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Switch.prototype, "inputedValue", {
            get: function () {
                return this.htmlElement.checked;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Switch.prototype, "inputedValueValidity", {
            get: function () {
                return this.htmlElement.validity;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Switch.prototype, "variable", {
            get: function () {
                return this.props.variable;
            },
            enumerable: false,
            configurable: true
        });
        Switch.prototype.updateValue = function (value) {
            this.setState({ value: value });
        };
        Switch.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
            if (this.props.variable.value !== nextProps.variable.value) {
                this.updateValue(nextProps.variable.value);
            }
        };
        Switch.prototype.render = function () {
            var _this = this;
            var switchAttributes = {
                "data-switch": "",
                className: this.props.style,
                disabled: !this.props.enabled,
                type: "checkbox",
                onChange: function (e) { return _this.onChange(e); },
                checked: this.state.value,
            };
            this.fillWithBuiltinProperties(switchAttributes);
            return React.createElement(HtmlTags_1.HtmlTags.span, null, React.createElement(HtmlTags_1.HtmlTags.input, switchAttributes), this.createValidationElement());
        };
        Switch = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], Switch);
        return Switch;
    }(Widget_1.InputWithVariableWidget));
    exports.Switch = Switch;
});
//# sourceMappingURL=Switch.js.map;
